import { useAnimationStore } from "@/components/common/explosion/exposion.store";

// Initialize AudioContext and audio buffer
// @ts-expect-error i know
const audioContext = new (window.AudioContext || window.webkitAudioContext)();
let audioBuffer: AudioBuffer | null = null;

// Preload audio during app initialization
export async function preloadAudio() {
  try {
    const response = await fetch("sounds/don-achievement.wav");
    const arrayBuffer = await response.arrayBuffer();
    audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
  } catch (error) {
    console.error("Audio loading failed:", error);
  }
}

// Play sound with Web Audio API
export const boom = (isPlaying = true) => {
  useAnimationStore.getState().showAnimation();

  if (!isPlaying || !audioBuffer) return;

  const playSound = () => {
    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(audioContext.destination);
    source.start(0);
  };

  if (audioContext.state === "suspended") {
    audioContext.resume().then(playSound);
  } else {
    playSound();
  }
};
